 
//GET PROFILE DATA
export const PROFILE = "/api/v1/crm/auth/profile";
 

// LOGIN PAGE
export const LOGIN = "/login";
export const API_BASE = "http://localhost:3001/api/v1/crm";
